module.exports = __webpack_public_path__ + "static/media/GT-Haptik-Medium.b0c54dbc.woff";